import services from 'services/services';
import * as types from '../../types';

// Import helpers
import { checkFetchErrors } from '../../helpers_actions/convert_helpers';

// ******************** FETCH ARTICLE AVAILABILITY DATA TO EDIT ********************
export const fetchArticleAvailabilityForm = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_ARTICLE_AVAILABILITY_FORM_LOADING,
			payload: true
		});

		const response = await services.get(`/timetables/availability/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_ARTICLE_AVAILABILITY_FORM_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_ARTICLE_AVAILABILITY_FORM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
